import { call, put } from 'redux-saga/effects';

import {
    fetchAnalyticsOverviewAPI,
    fetchApiSubscriptionsAPI,
    fetchAvailableRestApisAPI,
    fetchPartnerUsageSummaryAPI,
    fetchUsagePlansListAPI,
    updateUsagePlanForApiAPI,
} from '../../apis';

import * as adminActions from '../actions';

/**
 * Fetch API subscriptions saga
 *
 * @method fetchApiSubscriptionsSaga
 * @type   {Generator}
 * @param  {Object} action The redux action (expects action.payload as params)
 * @return {Object}
 */
export function* fetchApiSubscriptionsSaga(action) {
    try {
        const { payload: params } = action;
        const response = yield call(fetchApiSubscriptionsAPI, params);
        const subscriptions = response?.data || {};
        yield put(adminActions.fetchApiSubscriptions.success(subscriptions));
        return subscriptions;
    } catch (error) {
        yield put(adminActions.fetchApiSubscriptions.error(error));
        return error;
    }
}

/**
 * Fetch available REST APIs for dropdown population
 *
 * @method fetchAvailableRestApisSaga
 * @type   {Generator}
 * @param  {Object} action The redux action (expects action.payload as params)
 * @return {Object}
 */
export function* fetchAvailableRestApisSaga(action) {
    try {
        const {
            payload: { name },
        } = action;
        const response = yield call(fetchAvailableRestApisAPI, { name });
        const restApisList = response?.data || {};
        yield put(adminActions.fetchAvailableRestApis.success(restApisList));
        return restApisList;
    } catch (error) {
        yield put(adminActions.fetchAvailableRestApis.error(error));
        return error;
    }
}

export function* fetchUsagePlansListSaga(action) {
    try {
        const { payload: params } = action;
        const response = yield call(fetchUsagePlansListAPI, params);
        const usagePlansList = response?.data || {};
        yield put(adminActions.fetchUsagePlansList.success(usagePlansList));
        return usagePlansList;
    } catch (error) {
        yield put(adminActions.fetchUsagePlansList.error(error));
        return error;
    }
}

export function* updateUsagePlanForApiSaga(action) {
    try {
        const { payload: updatedUsagePlanInfo } = action;
        const response = yield call(updateUsagePlanForApiAPI, updatedUsagePlanInfo);
        const updateUsagePlanResponse = response?.data || {};
        yield put(adminActions.updateUsagePlanForApi.success(updateUsagePlanResponse));
        return updateUsagePlanResponse;
    } catch (error) {
        yield put(adminActions.updateUsagePlanForApi.error(error));
        return error;
    }
}

/**
 * Fetch Analytics Overview saga
 *
 * @method fetchAnalyticsOverviewSaga
 * @type   {Generator}
 * @param  {Object} action The redux action
 * @return {Object}
 */
export function* fetchAnalyticsOverviewSaga(action) {
    try {
        const { payload: params } = action;
        const response = yield call(fetchAnalyticsOverviewAPI, params);
        const overview = response?.data ?? {};
        yield put(adminActions.fetchAnalyticsOverview.success(overview));
        return overview;
    } catch (error) {
        yield put(adminActions.fetchAnalyticsOverview.error(error));
        return error;
    }
}

export function* fetchPartnerUsageSummarySaga(action) {
    try {
        const { payload: params } = action;
        const response = yield call(fetchPartnerUsageSummaryAPI, params);
        const summary = response?.data ?? {};
        yield put(adminActions.fetchPartnerUsageSummary.success(summary));
        return summary;
    } catch (error) {
        yield put(adminActions.fetchPartnerUsageSummary.error(error));
        return error;
    }
}
